import { render, staticRenderFns } from "./CVSchemaList.vue?vue&type=template&id=0ff2bde6&scoped=true&"
import script from "./CVSchemaList.vue?vue&type=script&lang=js&"
export * from "./CVSchemaList.vue?vue&type=script&lang=js&"
import style0 from "./CVSchemaList.vue?vue&type=style&index=0&id=0ff2bde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2bde6",
  null
  
)

export default component.exports